import type { AlpineComponent } from 'alpinejs'
import Swiper from 'swiper'
import { Pagination, Navigation, A11y, Mousewheel } from 'swiper/modules'
import 'swiper/css'

export function RecipeSlider(): AlpineComponent<{
  swiper: Swiper | undefined
  init(): void
  discard(): void
}> {
  return {
    swiper: undefined,

    init() {
      this.swiper = new Swiper(this.$refs.slider, {
        modules: [Pagination, Navigation, A11y, Mousewheel],
        slidesPerView: 1.125,
        breakpoints: {
          600: {
            slidesPerView: 1.75,
          },
          780: {
            slidesPerView: 2.25,
          },
          1024: {
            slidesPerView: 1.75,
          },
          1200: {
            slidesPerView: 2.25,
          },
          1400: {
            slidesPerView: 2.75,
          },
          1600: {
            slidesPerView: 3.25,
          },
          2000: {
            slidesPerView: 4.25,
          },
          2400: {
            slidesPerView: 5.25,
          },
        },
        slidesOffsetBefore: 32,
        slidesOffsetAfter: 32,
        spaceBetween: 24,
        grabCursor: true,
        navigation: {
          nextEl: this.$refs.next,
          prevEl: this.$refs.prev,
          disabledClass: 'opacity-50 cursor-not-allowed',
        },
        pagination: {
          el: this.$refs.pagination,
          type: 'progressbar',
          clickable: true,
        },
        mousewheel: {
          forceToAxis: true,
        },
        observer: true,
        observeParents: true,
      })
    },

    discard() {
      this.swiper && this.swiper.destroy()
    },
  }
}
